import { QCSBaseTypedObject } from './QCSBaseTypedObject';

export class QCSChar extends QCSBaseTypedObject<string> {
  public constructor(charValue: string) {
    super(charValue);
    this.value = charValue;
  }
}
